import GeofenceInfoWindow from "./geofenceInfoWindow";

export default GeofenceInfoWindow;
